import React, { useState, useEffect } from 'react';
import { getScheduleByDevice, saveschedule, deleteschedule } from '../components/DbServices';
import Swal from 'sweetalert2';
import { getStoredUser } from '../utilities/encryption';

export default function ScheduleModal({ device, onClose }) {
  const [schedules, setSchedules] = useState([]);
  const [formData, setFormData] = useState({ to_number: '', message: '', schedule_time: '' });
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchSchedules = async () => {
    try {
      setFetching(true);
      const res = await getScheduleByDevice(device.id);
      setSchedules(res.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    if (device?.id) fetchSchedules();
  }, [device.id]);

  const handleSave = async () => {
    if (!formData.to_number || !formData.schedule_time) return Swal.fire("Fill all fields");
    setLoading(true);
    debugger
    try {
      const res = await saveschedule({
        ...formData,
        device_id: device.id,
       // user_id: JSON.parse(getStoredUser())?.data?.id
       user_id:device.user_id
      });
      debugger
      if (res.status === 200 || res.success) {
        setFormData({ to_number: '', message: '', schedule_time: '' });
        fetchSchedules();
        Swal.fire("Message Scheduled Successfully!");
      }
    } catch (err) {
      Swal.fire("Error scheduling");
    } finally {
      setLoading(false);
    }
  };

  const filteredSchedules = schedules.filter(s =>
    s.to_number?.includes(searchTerm) || s.message?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="custom-modal-backdrop" style={{ alignItems: 'flex-start', paddingTop: '30px' }}>
      <div className="custom-modal border-0 shadow-lg" style={{ maxWidth: '1000px', width: '95%', borderRadius: '20px', overflow: 'hidden', padding: '0' }}>
        
        {/* Header with your Gradient Class */}
        <div className="bg-primary p-4 d-flex justify-content-between align-items-center text-white">
          <div>
            <h5 className="fw-bold mb-0">Message Scheduler Dashboard</h5>
            <p className="mb-0 x-small text-white-50">Device: {device.device_name} (ID: {device.id})</p>
          </div>
          <button className="btn btn-light btn-sm rounded-pill px-3 fw-bold" onClick={onClose}>Close</button>
        </div>

        <div className="container-fluid">
          <div className="row">
            {/* Left Side: Creation Form */}
            <div className="col-lg-4 bg-light p-4" style={{ minHeight: '550px' }}>
              <h6 className="fw-bold mb-3 text-primary small text-uppercase">1. Create New Schedule</h6>
              <div className="card border-0 shadow-sm rounded-3 p-3">
                <div className="mb-3">
                  <label className="x-small fw-bold text-muted">Recipient Number</label>
                  <input 
                    className="form-control form-control-sm" 
                    placeholder="e.g. 919876543210" 
                    value={formData.to_number}
                    onChange={e => setFormData({...formData, to_number: e.target.value})} 
                  />
                </div>

                <div className="mb-3">
                  <label className="x-small fw-bold text-muted">Message Content</label>
                  <textarea 
                    className="form-control form-control-sm" 
                    rows="6" 
                    placeholder="Enter message..." 
                    value={formData.message}
                    onChange={e => setFormData({...formData, message: e.target.value})} 
                  />
                </div>

                <div className="mb-4">
                  <label className="x-small fw-bold text-muted">Execution Time</label>
                  <input 
                    type="datetime-local" 
                    className="form-control form-control-sm" 
                    value={formData.schedule_time}
                    onChange={e => setFormData({...formData, schedule_time: e.target.value})} 
                  />
                </div>

                <button className="btn btn-primary w-100 fw-bold py-2 shadow-sm" onClick={handleSave} disabled={loading}>
                  {loading ? 'Processing...' : 'Confirm Schedule'}
                </button>
              </div>
            </div>

            {/* Right Side: List View */}
            <div className="col-lg-8 p-4 bg-white">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="fw-bold mb-0 color-theme">
                  <i className="bi bi-calendar-check me-2"></i>
                  Scheduled Message Queue
                </h6>
                <div className="input-group input-group-sm w-50">
                  <span className="input-group-text bg-white border-end-0"><i className="bi bi-search"></i></span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0"
                    placeholder="Search schedules..."
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>

              <div style={{ minHeight: '400px', overflowY: 'auto', maxHeight: '500px' }}>
                {fetching ? (
                  <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                ) : filteredSchedules.length === 0 ? (
                  <div className="text-center py-5">
                    <p className="text-muted small">No schedules found for this device.</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle border-top">
                      <thead className="bg-light">
                        <tr className="x-small text-uppercase fw-bold text-muted">
                          <th>Recipient</th>
                          <th>Schedule Time</th>
                          <th>Status</th>
                          <th className="text-end">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredSchedules.map(item => (
                          <tr key={item.id} className="small">
                            <td className="fw-bold">{item.to_number}</td>
                            <td>
                              <div className="d-flex flex-column">
                                <span className="text-dark">{item.schedule_time}</span>
                                {item.status === 'sent' && <span className="x-small text-success">Sent: {item.updated_at}</span>}
                              </div>
                            </td>
                            <td>
                              <span className={`badge rounded-pill ${
                                item.status === 'sent' ? 'bg-success-subtle text-success border border-success' : 
                                item.status === 'pending' ? 'bg-warning-subtle text-warning border border-warning' : 
                                'bg-danger-subtle text-danger border border-danger'
                              } px-2 py-1`}>
                                {item.status.toUpperCase()}
                              </span>
                            </td>
                            <td className="text-end">
                              {item.status === 'pending' && (
                                <button 
                                  className="btn btn-sm btn-outline-danger border-0" 
                                  onClick={() => deleteschedule(item.id).then(fetchSchedules)}
                                >
                                  🗑️
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}